import { SPResourcePath as SimpleUri, SPResourcePathFormat as UriFormat } from '@ms/sp-resource-path';
export { SimpleUri, UriFormat };
export default SimpleUri;
